export default {
	logout: {
		ok: 'Déconnexion réalisée avec succès',
		expired: 'Votre session a expirée'
	},
	error: 'Une erreur technique est survenue, veuillez essayer ultérieurement',
	errorForm: 'Il y a des erreurs dans le formulaire'
};
